import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Link,
  Alert,
  CircularProgress,
} from '@mui/material';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';

const LoginContainer = styled(Paper)`
  padding: 40px;
  margin-top: 40px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    userType: 'provider'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Validar email
      if (!formData.email || !formData.email.includes('@')) {
        throw new Error('Por favor, insira um email válido');
      }

      // Validar senha
      if (!formData.password || formData.password.length < 6) {
        throw new Error('A senha deve ter pelo menos 6 caracteres');
      }

      console.log('Tentando fazer login...');
      const result = await login(formData.email, formData.password);
      console.log('Resultado do login:', result);

      if (result.success) {
        // Redirecionar para o painel se for um profissional
        if (result.user && result.user.userType === 'provider') {
          console.log('Redirecionando para o dashboard do profissional...');
          navigate('/provider/dashboard', { replace: true });
        } else {
          console.log('Redirecionando para a página inicial...');
          navigate('/', { replace: true });
        }
      } else {
        setError(result.message || 'Erro ao fazer login. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro no login:', error);
      setError(error.message || 'Erro ao fazer login. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <LoginContainer elevation={3}>
        <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
          Contrato Seguro
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom align="center">
          Login de Profissional
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            required
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            error={!!error && error.includes('email')}
            helperText={error && error.includes('email') ? error : ''}
            disabled={loading}
          />
          <TextField
            label="Senha"
            type="password"
            fullWidth
            required
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            error={!!error && error.includes('senha')}
            helperText={error && error.includes('senha') ? error : ''}
            disabled={loading}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </Form>

        <Box mt={2} textAlign="center">
          <Typography variant="body2">
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/forgot-password')}
              disabled={loading}
            >
              Esqueceu a senha?
            </Link>
          </Typography>
        </Box>
        <Box mt={2} textAlign="center">
          <Typography variant="body2">
            Não tem uma conta?{' '}
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate('/register/professional')}
              disabled={loading}
            >
              Cadastre-se
            </Link>
          </Typography>
        </Box>
      </LoginContainer>
    </Container>
  );
};

export default Login; 